import { FelaCSSWithCustomSelectors, spacing } from '@bridebook/ui';

interface IStyles {
  image: FelaCSSWithCustomSelectors;
  imageMobile: FelaCSSWithCustomSelectors;
  imageDesktop: FelaCSSWithCustomSelectors;
  imageDesktopWrapper: FelaCSSWithCustomSelectors;
  tileComponent: FelaCSSWithCustomSelectors;
  innerWrapper: FelaCSSWithCustomSelectors;
  firstColumn: FelaCSSWithCustomSelectors;
  secondColumn: FelaCSSWithCustomSelectors;
  title: FelaCSSWithCustomSelectors;
  body: FelaCSSWithCustomSelectors;
  button: FelaCSSWithCustomSelectors;
}

const styles: IStyles = {
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  imageMobile: {
    maxWidth: '240px',
    '@container (width > 768px)': {
      display: 'none',
    },
  },
  imageDesktop: {
    maxWidth: '320px',
  },
  imageDesktopWrapper: {
    display: 'none',
    '@container (width > 768px)': {
      display: 'flex',
    },
  },
  tileComponent: {
    paddingTop: spacing[12],
  },
  innerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    '@container (width > 768px)': {
      paddingHorizontal: spacing[6],
    },
  },
  firstColumn: {
    width: '100%',
    gap: spacing[10],
    alignItems: 'center',
    '@container (width > 768px)': {
      width: '40%',
      gap: spacing[8],
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
  },
  secondColumn: {
    '@container (width > 768px)': {
      flexGrow: 1,
      alignItems: 'flex-end',
    },
  },

  title: {
    textAlign: 'center',
    '@container (width > 768px)': {
      textAlign: 'left',
    },
  },
  body: {
    textAlign: 'center',
    '@container (width > 768px)': {
      textAlign: 'left',
    },
  },
  button: {
    minWidth: '250px',
  },
};

export default styles;
